/* ─── Responsive nav ─── */
(function(){
  function handleResize(){
    const w=window.innerWidth;
    const desktopNav=document.querySelector('.desktop-nav');
    const navCta=document.getElementById('navCta');
    const mobToggle=document.querySelector('.mob-toggle');
    if(w>=1024){
      if(desktopNav)desktopNav.style.display='flex';
      if(navCta)navCta.style.display='inline-flex';
      if(mobToggle)mobToggle.style.display='none';
    }else{
      if(desktopNav)desktopNav.style.display='none';
      if(navCta)navCta.style.display='none';
      if(mobToggle)mobToggle.style.display='flex';
    }
  }
  handleResize();
  window.addEventListener('resize',handleResize);
})();

/* ─── State ─── */
const state={
  qty:1,
  color:'blue',
  colorNames:{blue:'Niebieski Ocean',pink:'Różowy Candy',mint:'Miętowy Forest'},
  colorImages:{
    blue:'https://www.aparacikowo.pl/wp-content/uploads/2026/09/1.1.png',
    pink:'https://www.aparacikowo.pl/wp-content/uploads/2026/09/1.3.png',
    mint:'https://www.aparacikowo.pl/wp-content/uploads/2026/09/1.2.png'
  },
  colorGrad:{
    blue:'linear-gradient(135deg,rgba(37,99,235,.15),rgba(96,165,250,.1))',
    pink:'linear-gradient(135deg,rgba(244,114,182,.12),rgba(251,207,232,.08))',
    mint:'linear-gradient(135deg,rgba(52,211,153,.12),rgba(167,243,208,.08))'
  },
  colorGlow:{
    blue:'radial-gradient(circle,rgba(59,130,246,.55),rgba(59,130,246,0) 70%)',
    pink:'radial-gradient(circle,rgba(244,114,182,.55),rgba(244,114,182,0) 70%)',
    mint:'radial-gradient(circle,rgba(52,211,153,.55),rgba(52,211,153,0) 70%)'
  }
};
const prefersReducedMotion=window.matchMedia('(prefers-reduced-motion: reduce)').matches;

/* ─── Video ─── */
let videoPlaying=false;
function toggleVideo(){
  const vid=document.getElementById('productVideo');
  const overlay=document.getElementById('videoOverlay');
  if(!vid)return;
  if(videoPlaying){vid.pause();overlay.style.display='flex';videoPlaying=false;}
  else{vid.muted=false;vid.play().catch(()=>{vid.muted=true;vid.play();});overlay.style.display='none';videoPlaying=true;}
}

/* ─── Color helpers ─── */
function setHeroColor(color){
  state.color=color;
  const img=document.getElementById('heroCamImg');
  const wrap=document.getElementById('heroImgWrap');
  const glow=document.getElementById('heroGlow');
  if(img){
    if(prefersReducedMotion||img.src===state.colorImages[color]){img.src=state.colorImages[color];}
    else{img.classList.add('swapping');setTimeout(()=>{img.src=state.colorImages[color];img.classList.remove('swapping');},170);}
  }
  if(wrap)wrap.style.background=state.colorGrad[color];
  if(glow)glow.style.background=state.colorGlow[color];
  ['blue','pink','mint'].forEach(c=>{
    const dot=document.getElementById('hdot-'+c);
    if(dot){
      dot.style.outlineOffset=c===color?'2px':'';
      dot.style.outline=c===color?'2px solid '+{blue:'#3B82F6',pink:'#F472B6',mint:'#34D399'}[c]:'none';
      dot.classList.toggle('active',c===color);
    }
  });
}

function setOrderColor(color){
  state.color=color;
  const lbl=document.getElementById('selectedColorLabel');
  if(lbl)lbl.textContent=state.colorNames[color];
  buildGallery(color);
  buildExtraGallery(color);
  ['blue','pink','mint'].forEach(c=>{
    const btn=document.getElementById('colBtn-'+c);
    if(btn){btn.classList.toggle('active',c===color);btn.setAttribute('aria-checked',c===color);}
  });
  setHeroColor(color);
}

/* ─── Qty ─── */
function changeQty(d){
  state.qty=Math.max(1,Math.min(10,state.qty+d));
  document.getElementById('qtyDisplay').textContent=state.qty;
}

/* ─── Shopify Cart Integration ─── */
function addToCart(){
  const formData = {
    'items': [{
      'id': window.ShopifyProductVariantId || 1,
      'quantity': state.qty,
      'properties': { 'Kolor': state.colorNames[state.color] }
    }]
  };

  fetch(window.Shopify ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(formData)
  })
  .then(res => res.json())
  .then(() => {
    updateCartUI();
    fireConfetti();
    showToast();
  })
  .catch(() => {
    fireConfetti();
    showToast();
  });
}

function updateCartUI(){
  fetch(window.Shopify ? window.Shopify.routes.root + 'cart.js' : '/cart.js')
  .then(res => res.json())
  .then(cart => {
    const count = cart.item_count || 1;
    const total = cart.total_price ? (cart.total_price / 100).toFixed(2) : 79;
    document.getElementById('cartCount').textContent = count;
    document.getElementById('cartTotal').textContent = total + ' zł';
    
    const container = document.getElementById('cartItems');
    const empty = document.getElementById('cartEmpty');
    const footer = document.getElementById('cartFooter');
    
    if(!cart.items || cart.items.length === 0){
      if(empty)empty.style.display='block';
      if(footer)footer.style.display='none';
      return;
    }
    if(empty)empty.style.display='none';
    if(footer)footer.style.display='block';

    container.innerHTML = cart.items.map((item) => `
      <div style="display:flex;gap:12px;align-items:center;background:rgba(255,255,255,.04);border:1px solid rgba(96,165,250,.1);border-radius:16px;padding:12px;margin-bottom:10px">
        <div style="width:56px;height:56px;background:rgba(37,99,235,.12);border-radius:12px;display:flex;align-items:center;justify-content:center;font-size:24px;flex-shrink:0">📷</div>
        <div style="flex:1;min-width:0">
          <p style="font-weight:700;font-size:12px;color:#e8f0fe">${item.product_title}</p>
          <p style="font-size:11px;color:#93b8e8;margin-top:2px">Karta 32GB w zestawie</p>
        </div>
        <div style="text-align:right;flex-shrink:0">
          <p style="font-weight:800;font-size:14px;color:#60A5FA">${(item.final_line_price/100).toFixed(2)} zł</p>
        </div>
      </div>
    `).join('');
  })
  .catch(() => {});
}

function openCart(){document.getElementById('cartDrawer').style.transform='translateX(0)';document.getElementById('cartOverlay').style.display='block';document.body.style.overflow='hidden';}
function closeCart(){document.getElementById('cartDrawer').style.transform='';document.getElementById('cartOverlay').style.display='none';document.body.style.overflow='';}

/* ─── Wishlist ─── */
function toggleWishlist(){
  state.wishlist=!state.wishlist;
  const icon=document.getElementById('wishIcon');
  const count=document.getElementById('wishCount');
  if(state.wishlist){icon.setAttribute('fill','#F472B6');count.style.display='flex';}
  else{icon.setAttribute('fill','none');count.style.display='none';}
}

/* ─── Toast & Confetti ─── */
let toastTimer;
function showToast(){const t=document.getElementById('toast');t.classList.add('show');clearTimeout(toastTimer);toastTimer=setTimeout(()=>t.classList.remove('show'),3500);}
function closeToast(){document.getElementById('toast').classList.remove('show');}

function fireConfetti(){
  if(window.matchMedia('(prefers-reduced-motion:reduce)').matches)return;
  const cols=['#3B82F6','#F472B6','#34D399','#FBBF24','#A78BFA'];
  for(let i=0;i<50;i++){
    const el=document.createElement('div');
    el.className='confetti-piece';
    const size=Math.random()*10+5;
    el.style.cssText=`left:${Math.random()*100}vw;width:${size}px;height:${size}px;background:${cols[i%cols.length]};border-radius:${Math.random()>.5?'50%':'3px'};animation-duration:${Math.random()*.8+.7}s;animation-delay:${Math.random()*.3}s`;
    document.body.appendChild(el);
    el.addEventListener('animationend',()=>el.remove());
  }
}

/* ─── Countdown ─── */
(function(){
  let secs=5*3600+12*60+45;
  setInterval(()=>{
    if(secs<=0)return;
    secs--;
    const h=String(Math.floor(secs/3600)).padStart(2,'0');
    const m=String(Math.floor((secs%3600)/60)).padStart(2,'0');
    const s=String(secs%60).padStart(2,'0');
    const el=document.getElementById('cdTimer');
    if(el)el.textContent=`${h}:${m}:${s}`;
  },1000);
})();

/* ─── Scroll & Reveals ─── */
window.addEventListener('scroll',()=>{
  const prog=document.getElementById('scrollProg');
  const h=document.documentElement.scrollHeight-document.documentElement.clientHeight;
  if(prog)prog.style.width=(window.scrollY/h*100)+'%';
},{passive:true});

const revealObs=new IntersectionObserver(entries=>{
  entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add('visible');revealObs.unobserve(e.target);}});
},{threshold:0.1});
document.querySelectorAll('.reveal').forEach(el=>revealObs.observe(el));

/* ─── FAQ ─── */
const faqs=[
  {q:'Czy karta pamięci jest naprawdę w zestawie?',a:'Tak! Każdy aparat Aparacikowo jest dostarczany z szybką kartą MicroSD 32GB już w pudełku — bez żadnych ukrytych kosztów. Wystarczy rozpakować i zacząć fotografować.'},
  {q:'Na jaki wiek polecacie aparat?',a:'Aparat jest zaprojektowany dla dzieci w wieku 3–12 lat. Intuicyjny interfejs opanuje nawet trzylatek, a zaawansowane funkcja bawią starsze dzieci przez lata.'},
  {q:'Czy aparat jest bezpieczny dla dzieci?',a:'Obudowa wykonana jest z atestowanego, certyfikowanego silikonu — wolnego od BPA i ftalanów. Produkt spełnia normy CE i posiada certyfikat bezpieczeństwa EN 71.'},
  {q:'Co się stanie, jeśli aparat upadnie?',a:'Silikonowa obudowa pochłania energię uderzenia i chroni wnętrze przed uszkodzeniem. Aparat przeszedł testy upadkowe z wysokości do 1 metra.'},
  {q:'Jak szybko wyślecie zamówienie?',a:'Zamówienia złożone do godziny 14:00 w dni robocze wysyłamy jeszcze tego samego dnia kurierem DPD lub InPost. Dostarczamy w 24h na terenie Polski.'},
  {q:'Jak wygląda polityka zwrotów?',a:'Masz pełne 14 dni na zwrot bez podawania przyczyny. Wystarczy odesłać nieuszkodzony produkt, a pieniądze wrócą na Twoje konto w ciągu 3 dni roboczych.'},
  {q:'Czy mogę kupić aparat jako prezent?',a:'Oczywiście! Każdy aparat pakowany jest w ozdobne, kolorowe pudełko prezentowe — idealne pod choinkę, na urodziny lub Dzień Dziecka.'},
  {q:'Jakie metody płatności akceptujecie?',a:'Obsługujemy BLIK, karty Visa i Mastercard, przelew tradycyjny oraz płatność ratalną (0% przez 12 miesięcy przy zamówieniu powyżej 100 zł).'}
];

document.addEventListener('DOMContentLoaded',()=>{
  const faqList=document.getElementById('faqList');
  if(faqList){
    faqs.forEach((item,i)=>{
      const div=document.createElement('div');
      div.className='faq-item';
      div.innerHTML=`<button class="faq-btn" aria-expanded="false" aria-controls="fa${i}"><span>${item.q}</span><svg class="faq-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5"><path stroke-linecap="round" d="M19 9l-7 7-7-7"/></svg></button><div class="faq-answer" id="fa${i}" role="region"><p>${item.a}</p></div>`;
      faqList.appendChild(div);
    });
    document.querySelectorAll('.faq-btn').forEach(btn=>{
      btn.addEventListener('click',()=>{
        const open=btn.getAttribute('aria-expanded')==='true';
        document.querySelectorAll('.faq-btn').forEach(b=>{
          b.setAttribute('aria-expanded','false');
          b.nextElementSibling.classList.remove('open');
          b.querySelector('.faq-icon').style.transform='';
        });
        if(!open){
          btn.setAttribute('aria-expanded','true');
          btn.nextElementSibling.classList.add('open');
          btn.querySelector('.faq-icon').style.transform='rotate(180deg)';
        }
      });
    });
  }
});

/* ─── Gallery Data ─── */
const galleryData={
  blue:[{src:'https://www.aparacikowo.pl/wp-content/uploads/2026/09/2.jpg',alt:'Aparat niebieski przód i tył'},{src:'https://www.aparacikowo.pl/wp-content/uploads/2026/09/7.jpg',alt:'Aparat niebieski pod kątem'},{src:'https://www.aparacikowo.pl/wp-content/uploads/2026/09/8.jpg',alt:'Aparat niebieski tył'}],
  pink:[{src:'https://www.aparacikowo.pl/wp-content/uploads/2026/09/3.jpg',alt:'Aparat różowy w dłoni'},{src:'https://www.aparacikowo.pl/wp-content/uploads/2026/09/1.jpg',alt:'Aparat różowy przód i tył'}],
  mint:[{src:'https://www.aparacikowo.pl/wp-content/uploads/2026/09/4.jpg',alt:'Aparat miętowy z ekranem'},{src:'https://www.aparacikowo.pl/wp-content/uploads/2026/09/5.jpg',alt:'Aparat miętowy pod kątem'}]
};
const extraGalleryData={
  blue:[{src:'https://www.aparacikowo.pl/wp-content/uploads/2026/09/6.jpg',alt:'Aparat niebieski z boku',tag:'Detal'},{src:'https://www.aparacikowo.pl/wp-content/uploads/2026/09/9.jpg',alt:'Aparat niebieski w akcji',tag:'W akcji'}],
  pink:[],mint:[]
};

let galleryCurrent={color:'blue',idx:0};
let lightboxState={color:'blue',idx:0};

function combinedImages(color){return(galleryData[color]||[]).concat(extraGalleryData[color]||[]);}

function buildGallery(color){
  galleryCurrent.color=color;galleryCurrent.idx=0;
  const imgs=galleryData[color];
  const main=document.getElementById('galleryMainImg');if(main){main.src=imgs[0].src;main.alt=imgs[0].alt;}
  const cur=document.getElementById('galleryCurrent');const tot=document.getElementById('galleryTotal');if(cur)cur.textContent=1;if(tot)tot.textContent=imgs.length;
  const thumbsWrap=document.getElementById('galleryThumbs');if(thumbsWrap)thumbsWrap.innerHTML=imgs.map((img,i)=>`<div class="gallery-thumb${i===0?' active':''}" onclick="setGalleryIdx(${i})" role="button"><img src="${img.src}" alt="${img.alt}" loading="lazy"></div>`).join('');
  const dotsWrap=document.getElementById('galleryDots');if(dotsWrap)dotsWrap.innerHTML=imgs.map((_,i)=>`<button class="gallery-dot${i===0?' active':''}" onclick="setGalleryIdx(${i})"></button>`).join('');
  const wrap=document.getElementById('orderMainImg');if(wrap)wrap.style.background=state.colorGrad[color];
}

function buildExtraGallery(color){
  const grid=document.getElementById('extraGalleryGrid');const emptyMsg=document.getElementById('extraGalleryEmpty');const imgs=extraGalleryData[color]||[];if(!grid)return;
  if(!imgs.length){grid.style.display='none';grid.innerHTML='';if(emptyMsg)emptyMsg.style.display='block';return;}
  grid.style.display='grid';if(emptyMsg)emptyMsg.style.display='none';
  const mainLen=(galleryData[color]||[]).length;
  grid.innerHTML=imgs.map((img,i)=>`<div class="extra-thumb" style="position:relative" onclick="openLightboxExtra('${color}',${mainLen+i})" role="button"><img src="${img.src}" alt="${img.alt}" loading="lazy">${img.tag?`<span class="extra-thumb-tag">${img.tag}</span>`:''}</div>`).join('');
}

function setGalleryIdx(idx){
  const imgs=galleryData[galleryCurrent.color];galleryCurrent.idx=(idx+imgs.length)%imgs.length;const i=galleryCurrent.idx;
  const main=document.getElementById('galleryMainImg');if(main){main.style.opacity='0';setTimeout(()=>{main.src=imgs[i].src;main.alt=imgs[i].alt;main.style.opacity='1';},150);}
  document.querySelectorAll('.gallery-thumb').forEach((t,ti)=>t.classList.toggle('active',ti===i));
  document.querySelectorAll('.gallery-dot').forEach((d,di)=>d.classList.toggle('active',di===i));
  const cur=document.getElementById('galleryCurrent');if(cur)cur.textContent=i+1;
}

function galleryNav(dir){setGalleryIdx(galleryCurrent.idx+dir);}

/* ─── Lightbox ─── */
function showLightboxImage(){
  const imgs=combinedImages(lightboxState.color);
  const lb=document.getElementById('lightbox');
  const lbImg=document.getElementById('lightboxImg');
  if(!lb||!lbImg||!imgs.length)return;
  lbImg.src=imgs[lightboxState.idx].src;
  lbImg.alt=imgs[lightboxState.idx].alt;
  document.getElementById('lightboxCounter').textContent=(lightboxState.idx+1)+' / '+imgs.length;
  lb.classList.add('open');
  document.body.style.overflow='hidden';
}

function openLightbox(){lightboxState={color:galleryCurrent.color,idx:galleryCurrent.idx};showLightboxImage();}
function openLightboxExtra(color,idx){lightboxState={color,idx};showLightboxImage();}
function closeLightbox(){document.getElementById('lightbox').classList.remove('open');document.body.style.overflow='';}
function lightboxNav(dir){const imgs=combinedImages(lightboxState.color);if(!imgs.length)return;lightboxState.idx=(lightboxState.idx+dir+imgs.length)%imgs.length;showLightboxImage();}

document.addEventListener('keydown',e=>{
  const lb=document.getElementById('lightbox');
  if(!lb || !lb.classList.contains('open'))return;
  if(e.key==='Escape')closeLightbox();
  if(e.key==='ArrowLeft')lightboxNav(-1);
  if(e.key==='ArrowRight')lightboxNav(1);
});

/* ─── Init ─── */
document.addEventListener('DOMContentLoaded',()=>{
  setHeroColor('blue');
  buildGallery('blue');
  buildExtraGallery('blue');
  setOrderColor('blue');
  
  const menuBtn = document.getElementById('menuToggle');
  if(menuBtn){
    menuBtn.addEventListener('click',function(){
      const nav=document.getElementById('mobileNav');
      const open=nav.classList.toggle('open');
      this.setAttribute('aria-expanded',open);
      document.getElementById('ml1').style.transform=open?'rotate(45deg) translate(5px,5px)':'';
      document.getElementById('ml2').style.opacity=open?'0':'1';
      document.getElementById('ml3').style.transform=open?'rotate(-45deg) translate(4px,-5px)':'';
    });
  }
});